<template>
    <div v-if="show" class="modal-dialog-wrapper">
        <div class="modal fade" :class="{ show: show }" tabindex="-1" role="dialog" aria-hidden="true"
            :aria-labelledby="dialogId">
            <div class="modal-dialog" role="document" :class="{ 'modal-dialog-centered': centered }">
                <div class="modal-content">
                    <!-- Header -->
                    <div class="modal-header">
                        <h5 :id="dialogId" class="modal-title">{{ title }}</h5>
                        <button @click="handleClose" type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <slot></slot>
                    </div>

                    <!-- Footer -->
                    <div v-if="$slots.footer" class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="show" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
export default {
    name: 'ModalDialog',

    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        centered: {
            type: Boolean,
            default: true
        },
        confirmText: {
            type: String,
            default: 'Confirmer'
        },
        cancelText: {
            type: String,
            default: 'Annuler'
        },
        dialogId: {
            type: String,
            default: 'modal-dialog'
        }
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleConfirm() {
            this.$emit('confirm');
        }
    },

    mounted() {
        // Add event listener for escape key
        document.addEventListener('keydown', (e) => {
            if (this.show && e.key === 'Escape') {
                this.handleClose();
            }
        });
    },

    beforeDestroy() {
        // Remove event listener
        document.removeEventListener('keydown', this.handleClose);
    }
}
</script>

<style scoped>
.modal-dialog-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    display: block;
    position: relative;
    z-index: 10000;
    width: 100%;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
}

.modal-header {
    padding: 1rem;
}

.modal-body {
    padding: 1rem;
}

.modal-footer {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
}

.fade {
    transition: opacity 0.15s linear;
}

.fade.show {
    opacity: 1;
}
</style>
